import { Button, Divider, Flex, useDisclosure, Text, Box, Select } from "@chakra-ui/react";
import { BsFunnel } from "react-icons/bs";

import { EstadoNECStats } from "components/Portfolio/Mapa/MapaSideBar/Components//EstadoNECStats";
import { EstadoITEStats } from "components/Portfolio/Mapa/MapaSideBar/Components/EstadoITEStats";
import { FilterModal } from "components/Portfolio/Mapa/MapaSideBar/Components/FilterModal";
import { FreeTextInput } from "components/Portfolio/Mapa/MapaSideBar/Components/FreeTextInput";
import { actions as portfolioActions } from "store/portfolio/reducer";
import { useAppDispatch, useAppSelector } from "store/store";
import { actions as userActions } from "store/user/reducer";

export function MapSideBarBody() {
	const { isOpen, onOpen, onClose } = useDisclosure();
	const dispatch = useAppDispatch();
	const mapViewStats = useAppSelector((state) => state.portfolio.mapViewStats);

	return (
		<>
			<Box mt="1rem">
				<FreeTextInput />
			</Box>
			<Divider margin="1rem 0rem" />
			<Select defaultValue="default" my=".5rem" onChange={(e) => dispatch(userActions.setStyle(e.target.value))}>
				<option value="default">Vista mapa</option>
				<option value="satellite">Vista satélite</option>
			</Select>
			<Divider margin="1rem 0rem" />
			<Flex flexDirection="row" justifyContent="space-between" marginTop="1rem" gap="1rem">
				<Text textStyle="body3" color="gray.600" alignSelf="center">
					Filtros Avanzados
				</Text>
				<Button variant="solid" height="1.75rem" onClick={onOpen}>
					<BsFunnel />
				</Button>
			</Flex>
			<FilterModal isOpen={isOpen} onClose={onClose} />
			<Divider margin="1rem 0rem" />
			<Select
				value={mapViewStats}
				my=".5rem"
				onChange={(e) => dispatch(portfolioActions.setMapViewStats(e.target.value as "estadoITE" | "indiceNEC"))}
			>
				<option value="indiceNEC">Estado Conservación</option>
				<option value="estadoITE">Estado ITE</option>
			</Select>
			{mapViewStats === "estadoITE" ? <EstadoITEStats /> : <EstadoNECStats />}
		</>
	);
}
